import { render, staticRenderFns } from "./SocialPostImageDraggable.vue?vue&type=template&id=b2397b28&"
import script from "./SocialPostImageDraggable.vue?vue&type=script&lang=js&"
export * from "./SocialPostImageDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2397b28')) {
      api.createRecord('b2397b28', component.options)
    } else {
      api.reload('b2397b28', component.options)
    }
    module.hot.accept("./SocialPostImageDraggable.vue?vue&type=template&id=b2397b28&", function () {
      api.rerender('b2397b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialPostImageDraggable.vue"
export default component.exports